import { render, staticRenderFns } from "./OnboardingRecord.vue?vue&type=template&id=97a1e644&scoped=true"
import script from "./OnboardingRecord.vue?vue&type=script&lang=ts"
export * from "./OnboardingRecord.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingRecord.vue?vue&type=style&index=0&id=97a1e644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a1e644",
  null
  
)

export default component.exports